import { useDates } from "../../../dates/DatesContext";
import { useFetch } from "../../../hooks/api";
import { HStack } from "../../../../styled-system/jsx";
import Card from "../../core/basic/Card";
import SummaryMetric from "../../core/blocks/SummaryMetric";
import {
  ATF_SOS_ORGANIC_TOOLTIP,
  ATF_SOS_TOOLTIP,
  ATF_SOV_TOOLTIP,
  AVERAGE_POSITION_TOOLTIP,
  SOS_ORGANIC_TOOLTIP,
  SOS_TOOLTIP,
  SOV_TOOLTIP,
} from "../../../utils/toolTips";
import { formatNumber } from "../../../utils/formatNumber";
import { css } from "../../../../styled-system/css";

export function AnalyticsStatsPanel() {
  const { start, end } = useDates();
  const shelfStatsQuery = useFetch(
    ["shelf_stats"],
    "/api/shelf_stats/",
    {
      stats_by: "shelf",
      end: end.toISOString(),
      start: start.toISOString(),
      summary: true,
    },
    {
      select: (data) => data.data,
    },
  );

  return (
    <HStack
      maxWidth={"100%"}
      overflowX="auto"
      padding={"small"}
      className={css({
        "&>div": {
          flex: "1 1 150px",
          minWidth: "150px",
        },
      })}
    >
      <Card>
        <SummaryMetric
          size={"small"}
          toolTip={SOS_TOOLTIP}
          name={"SOS"}
          value={shelfStatsQuery.data?.sos_average / 100}
          loading={shelfStatsQuery.isLoading}
          formatOptions={{ format: "percent", decimalPlaces: 1 }}
        />
      </Card>
      <Card>
        <SummaryMetric
          size={"small"}
          toolTip={SOS_ORGANIC_TOOLTIP}
          name={"SOS Organic"}
          value={shelfStatsQuery.data?.sos_organic_average / 100}
          loading={shelfStatsQuery.isLoading}
          formatOptions={{ format: "percent", decimalPlaces: 1 }}
        />
      </Card>
      <Card>
        <SummaryMetric
          size={"small"}
          toolTip={SOV_TOOLTIP}
          name={"SOV"}
          value={shelfStatsQuery.data?.sov_average / 100}
          loading={shelfStatsQuery.isLoading}
          formatOptions={{ format: "percent", decimalPlaces: 1 }}
        />
      </Card>
      <Card>
        <SummaryMetric
          size={"small"}
          toolTip={ATF_SOS_TOOLTIP}
          name={"ATF SOS"}
          value={shelfStatsQuery.data?.atf_sos_average / 100}
          loading={shelfStatsQuery.isLoading}
          formatOptions={{ format: "percent", decimalPlaces: 1 }}
        />
      </Card>
      <Card>
        <SummaryMetric
          size={"small"}
          toolTip={ATF_SOS_ORGANIC_TOOLTIP}
          name={"ATF SOS Organic"}
          value={shelfStatsQuery.data?.atf_sos_organic_average / 100}
          loading={shelfStatsQuery.isLoading}
          formatOptions={{ format: "percent", decimalPlaces: 1 }}
        />
      </Card>
      <Card>
        <SummaryMetric
          size={"small"}
          toolTip={ATF_SOV_TOOLTIP}
          name={"ATF SOV"}
          value={shelfStatsQuery.data?.atf_sov_average / 100}
          loading={shelfStatsQuery.isLoading}
          formatOptions={{ format: "percent", decimalPlaces: 1 }}
        />
      </Card>
      <Card>
        <SummaryMetric
          size={"small"}
          toolTip={AVERAGE_POSITION_TOOLTIP}
          name={"Average Position"}
          value={shelfStatsQuery.data?.position_average}
          loading={shelfStatsQuery.isLoading}
          formatter={(v) => formatNumber(v, { decimalPlaces: 0 })}
        />
      </Card>
    </HStack>
  );
}
